var selectFilters = function selectFilters(state) {
  return state.filters;
};
export var selectSortType = function selectSortType(state) {
  return selectFilters(state).sortType;
};
export var selectSearch = function selectSearch(state) {
  return selectFilters(state).search;
};
export var selectIsFiltersVisible = function selectIsFiltersVisible(state) {
  return selectFilters(state).isFiltersVisible;
};
export var selectIsFiltersEnabled = function selectIsFiltersEnabled(state) {
  return selectFilters(state).isFiltersEnabled;
};